<ui-grid [data]="collection"
         [expandedEntry]="expandedRow"
         [selectable]="false"
         [refreshable]="false"
         [noDataMessage]="'parameter_collection_no_' + type + '_parameters' | translate"
         (keydown.esc)="$event.stopImmediatePropagation();"
         (keydown.enter)="$event.stopImmediatePropagation();"
         expandMode="preserve"
         class="ui-parameter-input-list">
    <ui-grid-column [title]="'parameter_collection_title' | translate"
                    [resizeable]="false"
                    width="50%">
        <ng-template let-argument="data">
            <div class="value-container">
                <p mat-line
                   class="argument-type"
                   data-cy="argument-type">
                    {{ argument.clrType?.display }}
                </p>
                <div [matTooltip]="argument.name"
                     [class.errorMessage]="argument.required &&
                                           !argument.hasDefault &&
                                           argument.value == null"
                     mat-line
                     class="argument-name"
                     data-cy="argument-name">
                    {{ argument.name }}
                    <span *ngIf="argument.required"> *</span>
                </div>
            </div>
        </ng-template>
    </ui-grid-column>
    <ui-grid-column *ngIf="type === 'input'"
                    [title]="'parameter_collection_value' | translate"
                    width="40%">
        <ng-template let-argument="data">
            <ng-container *ngIf="argument.value == null; else argumentValue">
                <ng-container *ngLet="('parameter_collection_source_' + argument.source | translate) as sourceText">
                    <span *ngIf="!!argument.source"
                          [matTooltip]="sourceText"
                          class="no-value">
                        {{ sourceText }}
                    </span>
                </ng-container>
                <ng-container *ngLet="('parameter_collection_no_value' | translate) as noValueText">
                    <span *ngIf="!argument.source"
                          [matTooltip]="noValueText"
                          class="no-value">
                        {{ noValueText }}
                    </span>
                </ng-container>
            </ng-container>
            <ng-template #argumentValue>
                <span [matTooltip]="argument.value | json">
                    {{ argument.value | json }}
                </span>
            </ng-template>
        </ng-template>
    </ui-grid-column>
    <ui-grid-row-action>
        <ng-template let-argument="data">
            <ng-container *ngIf="editable">
                <ng-container *ngIf="argument !== expandedRow; else closeButton">
                    <button (click)="editEntry(argument)"
                            [matTooltip]="'parameter_collection_edit_value' | translate"
                            mat-icon-button
                            type="button">
                        <mat-icon svgIcon="uipath:Edit">
                        </mat-icon>
                    </button>
                    <button *ngIf="argument.value != null"
                            (click)="clear(argument)"
                            [matTooltip]="'parameter_collection_remove_value' | translate"
                            mat-icon-button
                            type="button">
                        <mat-icon>delete</mat-icon>
                    </button>
                </ng-container>
                <ng-template #closeButton>
                    <button (click)="close(argument)"
                            [matTooltip]="'parameter_collection_close_editor' | translate"
                            mat-icon-button
                            type="button">
                        <mat-icon>close</mat-icon>
                    </button>
                </ng-template>
            </ng-container>
        </ng-template>
    </ui-grid-row-action>
    <ui-grid-expanded-row>
        <ng-template let-argument="data">
            <div class="parameter-form">
                <form [formGroup]="formGroup"
                      (keydown.esc)="close(argument)"
                      (submit)="$event.preventDefault();
                                $event.stopImmediatePropagation();
                                save(argument)">
                    <ng-container [ngSwitch]="inputDefinition?.type">
                        <ng-container *ngSwitchCase="InputType.String">
                            <mat-form-field>
                                <input [placeholder]="argument.name"
                                       [formControlName]="argument.name"
                                       [name]="argument.name"
                                       [uiAutofocus]
                                       matInput
                                       class="form-control" />
                                <mat-hint *ngIf="formGroup.get(argument.name)?.hasError('maxlength')"
                                          [translateParams]="{
                                                type: argument.clrType?.display,
                                                max: formGroup.get(argument.name)?.getError('maxlength').requiredLength
                                            }"
                                          translate
                                          class="errorMessage">
                                    parameter_string_type_warning
                                </mat-hint>
                            </mat-form-field>
                        </ng-container>
                        <ng-container *ngSwitchCase="InputType.Number">
                            <mat-form-field>
                                <input [placeholder]="argument.name"
                                       [formControlName]="argument.name"
                                       [name]="argument.name"
                                       [uiRestrictInput]="inputDefinition!.restriction"
                                       [uiAutofocus]
                                       matInput
                                       class="form-control" />
                                <mat-hint *ngIf="formGroup.get(argument.name)?.hasError('wholeNumber')"
                                          [translateParams]="{
                                                type: argument.clrType?.display
                                            }"
                                          translate
                                          class="errorMessage">
                                    parameter_whole_number_warning
                                </mat-hint>
                                <mat-hint *ngIf="formGroup.get(argument.name)?.hasError('decimalNumber')"
                                          [translateParams]="{
                                                type: argument.clrType?.display
                                            }"
                                          translate
                                          class="errorMessage">
                                    parameter_decimal_number_warning
                                </mat-hint>
                                <mat-hint *ngIf="formGroup.get(argument.name)?.hasError('range')"
                                          [translateParams]="{
                                                type: argument.clrType?.display,
                                                min: formGroup.get(argument.name)?.getError('range').min,
                                                max: formGroup.get(argument.name)?.getError('range').max
                                            }"
                                          translate
                                          class="errorMessage">
                                    parameter_number_range_warning
                                </mat-hint>
                            </mat-form-field>
                        </ng-container>
                        <ng-container *ngSwitchCase="InputType.Boolean">
                            <mat-form-field>
                                <ui-toggle-switch [onString]="'parameter_collection_true' | translate"
                                                  [offString]="'parameter_collection_false' | translate"
                                                  [placeholder]="argument.name"
                                                  [formControlName]="argument.name">
                                </ui-toggle-switch>
                            </mat-form-field>
                        </ng-container>
                        <ng-container *ngSwitchCase="InputType.Complex">
                            <mat-form-field>
                                <textarea [formControlName]="argument.name"
                                          [placeholder]="argument.name"
                                          [uiAutofocus]
                                          matInput></textarea>
                                <mat-hint *ngIf="formGroup.get(argument.name)?.hasError('json')"
                                          [translateParams]="{
                                                type: argument.clrType?.display
                                            }"
                                          translate
                                          class="errorMessage">
                                    parameter_number_complex_object_warning
                                </mat-hint>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                    <div class="parameter-form-actions">
                        <button (click)="close(argument)"
                                mat-button
                                type="button"
                                color="warn">
                            {{ 'parameter_collection_cancel_edit' | translate }}
                        </button>
                        <button [disabled]="formGroup.pristine ||
                                            formGroup.invalid"
                                mat-button
                                type="submit"
                                color="primary">
                            {{ 'parameter_collection_save_edit' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </ng-template>
    </ui-grid-expanded-row>
</ui-grid>
